import { Users, DollarSign, Clock, CheckCircle } from "lucide-react";

export function StatsPanel({ stats }) {
  if (!stats) return null;

  const cards = [
    { label: "Total", value: stats.total_submissions, icon: Users, color: "text-zinc-400" },
    { label: "Paid", value: stats.paid, icon: DollarSign, color: "text-blue-400", valueColor: "text-blue-600" },
    { label: "In Progress", value: stats.in_progress, icon: Clock, color: "text-purple-400", valueColor: "text-purple-600" },
    { label: "Delivered", value: stats.delivered, icon: CheckCircle, color: "text-green-400", valueColor: "text-green-600" },
    { label: "Revenue", value: `$${stats.total_revenue_usd}`, icon: DollarSign, color: "text-green-500" },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-5 gap-4 mb-8">
      {cards.map((card) => (
        <div key={card.label} className="bg-white border border-zinc-200 p-4">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-xs text-zinc-500 uppercase font-medium">{card.label}</p>
              <p className={`text-2xl font-bold ${card.valueColor || "text-zinc-900"}`}>{card.value}</p>
            </div>
            <card.icon className={`w-6 h-6 ${card.color}`} />
          </div>
        </div>
      ))}
    </div>
  );
}
